import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { Selection } from '../types/general.types';
import { SelectedSystem } from '../types/selectedSystem.types';
import { SelectedSite } from '../types/selectedSite.types';
import { SelectedsystemService } from './selectedsystem.service';
import { SelectedSiteService } from './selectedsite.service';

@Injectable({ providedIn: 'root' })
export class SelectedContentService {
    private readonly _selection = new BehaviorSubject<Selection>({ kind: 'none' });
    readonly selection$ = this._selection.asObservable();
    $isLoadingContent: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    // “selectors”
    readonly selectedSystem$ = this.selection$.pipe(
        map(s => (s.kind === 'device' ? s.system : null)),
        distinctUntilChanged((a, b) =>
            (a?.SerialNumber ?? '') === (b?.SerialNumber ?? '') &&
            (a?.MaterialNumber ?? '') === (b?.MaterialNumber ?? '')
        ),
        shareReplay({ bufferSize: 1, refCount: true })
    );

    readonly selectedSite$ = this.selection$.pipe(
        map(s => (s.kind === 'site' ? s.site : null)),
        distinctUntilChanged((a, b) => (a?.Id ?? '') === (b?.Id ?? '')),
        shareReplay({ bufferSize: 1, refCount: true })
    );

    selectDevice(system: SelectedSystem) {
        this._selection.next({ kind: 'device', system });
        this.$isLoadingContent.next(false);
    }

    selectSite(site: SelectedSite) {
        this._selection.next({ kind: 'site', site });
        this.$isLoadingContent.next(false);
    }

    clear() {
        this._selection.next({ kind: 'none' });
    }

    get selection(): Selection {
        return this._selection.value;
    }

    get currentSite(): SelectedSite | null {
        const sel = this._selection.value;
        return sel.kind === 'site' ? sel.site : null;
    }

    get currentSystem(): SelectedSystem | null {
        const sel = this._selection.value;
        return sel.kind === 'device' ? sel.system : null;
    }
    
}